import _ from 'lodash'
import { getPrivacyManagerViewAjax } from '../../../api/consent_v2/privacy_manager'

// IAB TCF v4 mandates the features definition copy, so native OTT messages carry the
// standardText.features returned by privacy-manager-view instead of client authored text.
// See sp-consent-platform-v2/docs/tcfv4-client-rendering.md

export const FEATURES_DEFINITION_IDS = [
  'FeaturesDefinition',
  'FeaturesDefinitionConsent',
  'FeaturesDefinitionLegInt',
]

// Fetches every language in parallel. Returns { texts: { [language]: text | null }, failed: [language] },
// where null means the backend returned no standardText.features for that language.
export const fetchStandardFeaturesTexts = async ({ siteId, vendorListId, languages }) => {
  const texts = {}
  const failed = []
  await Promise.all(languages.map(language => (
    getPrivacyManagerViewAjax(siteId, vendorListId, language)
      .then((pmData) => {
        texts[language] = (pmData && pmData.standardText && pmData.standardText.features) || null
      })
      .catch((err) => {
        console.error(err)
        failed.push(language)
      })
  )))
  return { texts, failed }
}

// Writes the iab text onto every features definition component: the default language into
// settings.text (and settings.style.text when present), and every language into
// settings.languages[<lang>].text (including the default, so a stale authored override can never
// win in useTranslation). Languages whose text is null
// are left untouched. Returns the updated message, or null when nothing changed.
export const applyStandardFeaturesText = (message, texts, defaultLanguage) => {
  const entries = Object.entries(texts || {}).filter(([, text]) => text)
  if (!entries.length) return null

  let changed = false
  const clonedMessage = _.cloneDeep(message)

  const update = (component) => {
    if (FEATURES_DEFINITION_IDS.includes(component.id)) {
      const settings = component.settings = component.settings || {}
      entries.forEach(([language, text]) => {
        if (language === defaultLanguage) {
          if (settings.text !== text) {
            settings.text = text
            changed = true
          }
          // Text editors write into settings.style too, and renderers spread style over settings.
          if (settings.style && 'text' in settings.style && settings.style.text !== text) {
            settings.style.text = text
            changed = true
          }
        }
        settings.languages = settings.languages || {}
        const languageSettings = settings.languages[language] = settings.languages[language] || {}
        if (languageSettings.text !== text) {
          languageSettings.text = text
          changed = true
        }
      })
    }
    component.children && component.children.forEach(update)
  }
  clonedMessage.forEach(update)

  return changed ? clonedMessage : null
}
